module.exports = __webpack_public_path__ + "img/current-position-icon.2ecf09e8.svg";